// Called by : src/App.vue (modal-apr)

<template>
  <base-modal ref="base-modal" pageId="pge_apr" pageClass="infos" modalClass="modal-md"  modalDataBack="static" modalDataKey="false">

    {{ forceUpdate }}

      <template #header>
        <h4 class="modal-title" id="pge_apr_title">{{ sNameFull }}</h4>
        <button type="button" class="close d-none" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      <template #body>
        <div v-if="bPerso" id="row_apr_idn" class="rangee row"> <!--  v-if="bPerso"-->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_civ" id="apr_civ_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.civ') }}<span class="is_req">*</span></span>
              </label>
              <div class="form-control">
                <div class="form-check form-check-inline">
                  <input class="radio_input form-check-input" type="radio" name="apr_civ" id="apr_civ_1" value="1" v-model="nCiv">
                  <label class="radio_label form-check-label" for="apr_civ_1">{{ $t('learner.civMr') }}</label>
                </div>
                <!-- <input class="form_radio_input" type="radio" :id="proposal.index" v-model="answer" :value="proposal.zkp"> -->
                <div class="form-check form-check-inline">
                  <input class="radio_input form-check-input" type="radio" name="apr_civ" id="apr_civ_2" value="2" v-model="nCiv">
                  <label class="radio_label form-check-label" for="apr_civ_2">{{ $t('learner.civMm') }}</label>
                </div>
              </div>
            </div>
          </div> <!-- .col-md-12 -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_first_val" id="apr_first_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.first') }}<span class="is_req">*</span></span>
              </label>
              <input type="text" v-model.trim="sNameFirst" v-on:input="setCaps" class="apr_first form-control w-70" id="apr_first_val" name="apr_first_val" aria-describedby="apr-first">
            </div>
          </div> <!-- .col-md-12 -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_last_val" id="apr_last_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.last') }}<span class="is_req">*</span></span>
              </label>
              <input type="text" v-model.trim="sNameLast" v-on:input="setUpper" class="apr_last form-control w-70" id="apr_last_val" name="apr_last_val" aria-describedby="apr-last">
            </div>
          </div> <!-- .col-md-12 -->
        </div>

        <hr v-if="bPerso" class="sep"/>

        <div id="row_apr_datas" class="rangee row">
          <!-- col-xs-8 col-sm-10 col-md-12 px-xs-4  -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend" for="apr_birth_d_val" id="apr_birth_d_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.birth') }}<span class="is_req">*</span></span>
              </label>
              <input type="number" v-model.number="nBirthD" class="form-control w-15" id="apr_birth_d_val" name="apr_birth_d_val" :placeholder="$t('learner.dd')" min="1" max="31" step="1" aria-describedby="apr-birthday">
              <input type="number" v-model.number="nBirthM" class="form-control w-15" id="apr_birth_m_val" name="apr_birth_m_val" :placeholder="$t('learner.mm')" min="1" max="12" step="1" aria-describedby="apr-birthday">
              <input type="number" v-model.number="nBirthY" class="form-control w-20" id="apr_birth_y_val" name="apr_birth_y_val" :placeholder="$t('learner.yyyy')" min="1000" max="3000" step="1" aria-describedby="apr-birthday">
            </div>
          </div> <!-- .col-md-12  w-45 -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_metier_val" id="apr_metier_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.metier') }}</span>
              </label>
              <input type="text" v-model.trim="sMetier" class="form-control w-70" id="apr_metier_val" name="apr_metier_val" aria-describedby="apr-metier">
            </div>
          </div> <!-- .col-md-12 -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_mobile_val" id="apr_mobile_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.mobile') }}</span>
              </label>
              <input type="text" v-model.trim="sMobile" class="form-control w-70" id="apr_mobile_val" name="apr_mobile_val" aria-describedby="apr-mobile">
            </div>
          </div> <!-- .col-md-12 -->
          <div class="colonne col-12 px-md-4 px-lg-0">
            <div class="input-group">
              <label class="input-group-prepend w-30" for="apr_email_val" id="apr_email_lbl">
                <span class="input-group-text px-xs-2 px-sm-3 w-100">{{ $t('learner.email') }}</span>
              </label>
              <input type="text" v-model.trim="sEmail" class="form-control w-70" id="apr_email_val" name="apr_email_val" aria-describedby="apr-email">
            </div>
          </div> <!-- .col-md-12 -->
        </div> <!-- .row -->
        <p class="is_req">* {{ $t('valid.requiredField') }}</p>
      </template>

      <template #footer>
        <div class="w-100">
          <div class="btn-group bnt-block w-100">
              <button v-if="!bPerso || bIdn" class="btn btn-secondary btn-lg" data-dismiss="modal" @click="refuse">
                <span class="oi oi-ban mr-2"></span>
                {{ $t('modals.cancel') }}
              </button>
              <button class="btn btn-primary btn-lg" data-dismiss="modal" @click="accept" :disabled="getSaveBtnDisabled()">
                <span class="oi oi-check mr-2"></span>
                {{ $t('modals.save') }}
              </button>
          </div>
        </div>
      </template>

      {{ forceRefresh }}

  </base-modal>
</template>

<script>
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal'

export default {
  components: {
    BaseModal,
  },
  data() {
    return {
      sDate: '',
      nDateD: '', // day
      nDateM: '', // month
      nDateY: '', // year
      nBirthD: '', // day
      nBirthM: '', // month
      nBirthY: '', // year
      dBirth: '',
      sBirth: '',
      sMetier: '',
      sMobile: '',
      sEmail: '',
      nCiv: '',
      sNameFull: '',
      sNameFirst: '',
      sNameLast: '',
      sGhostFirst: '',
      sGhostLast: '',
      bGhost: false,
      bIdn: false,
      bPerso: false,
    }
  },
  methods: {
    setCaps(event) {
      this.sNameFirst = event.target.value.majusculeInitiales();
    },
    setUpper(event) {
      this.sNameLast = event.target.value.toUpperCase();
    },
    getSaveBtnDisabled() {
      if (this.bPerso) {
        if (f_isEmpty_m(this.nCiv)) return true;
        if (f_isEmpty_m(this.sNameFirst)) return true;
        if (f_isEmpty_m(this.sNameLast)) return true;
        this.sNameFull = this.getFullName();
      }
      if (f_isEmpty_m(this.nBirthD)) return true;
      if (f_isEmpty_m(this.nBirthM)) return true;
      if (f_isEmpty_m(this.nBirthY)) return true;

      var dataOld = this.getUserDataConcat(true);
      var dataNew = this.getUserDataConcat(false);
      return Boolean(dataOld == dataNew);
    },
    getFullName() {
      var listCiv = [this.$t('learner.civMr'), this.$t('learner.civMm')];
      var nro = this.nCiv - 1;
      return '' + listCiv[nro] + " " + this.sNameFirst + " " + this.sNameLast;
    },
    getUserDataConcat(bOld) {
      if (this.bPerso) {
        if (bOld) {
          return '' + this.getDateConcat(true,true) + this.user.metier + this.user.mobile + this.user.email + this.user.civility + this.user.firstGhost + this.user.lastGhost;
        } else {
          return '' + this.getDateConcat(false,true) + this.sMetier + this.sMobile + this.sEmail + this.nCiv + this.sNameFirst + this.sNameLast;
        }
      } else {
        if (bOld) {
          return '' + this.getDateConcat(true,true) + this.user.metier + this.user.mobile + this.user.email;
        } else {
          return '' + this.getDateConcat(false,true) + this.sMetier + this.sMobile + this.sEmail;
        }
      }
    },
    getDateDMY(sDate) {
      var aDate = sDate.split('/');
      var sD = Number(aDate[1]);
      var sM = Number(aDate[0]);
      var sY = Number(aDate[2]);
      var sDate = sD + sM + sY;
      this.nDateD = sD;
      this.nDateM = sM;
      this.nDateY = sY;
      this.nBirthD = sD;
      this.nBirthM = sM;
      this.nBirthY = sY;
      return sDate;
    },
    getDateConcat(bOld, bFr, sSep='') {
      if (bOld) {
        var sD = this.nDateD;
        var sM = this.nDateM;
        var sY = this.nDateY;
      } else {
        var sD = this.nBirthD;
        var sM = this.nBirthM;
        var sY = this.nBirthY;
      }
      if (bFr) {
        return '' + sD + sSep + sM + sSep + sY;
      } else {
        return '' + sM + sSep + sD + sSep + sY;
      }
    },
    accept() {
      var isIdn = 1;
      this.bIdn = Boolean(isIdn);

      // On enregistre les données dans Fm-V7
      this.model.setUserDatas(this.user, isIdn, this.nCiv, this.sNameFirst, this.sNameLast, this.getDateConcat(false,true,'/'), this.sMetier, this.sMobile, this.sEmail);
      
      // On mémorise les données dans VJs
      this.aprUpdate();
      $('#pge_apr').modal('hide');
    },
    refuse() {
      // this.aprInit();
      this.aprUpdate();
      $('#pge_apr').modal('hide');
    },
    aprInit() {
      this.nDateD = '';
      this.nDateM = '';
      this.nDateY = '';
      this.nBirthD = '';
      this.nBirthM = '';
      this.nBirthY = '';

      var sDate = this.user.birthday.toString();
      if (sDate) {
        this.sDate = this.getDateDMY(sDate);
        this.sBirth = this.getDateDMY(sDate);
        this.dBirth = Date.parse(this.sBirth);
      }

      this.sMetier = this.user.metier;
      this.sMobile = this.user.mobile;
      this.sEmail = this.user.email;
      this.bGhost = this.user.ghostOk;
      this.bIdn = this.user.newIdnOk;
      this.bPerso = this.user.persoIdnOk;
      this.nCiv = this.user.civility;
      
      this.sNameFull = this.user.fullName;
      this.sNameFirst = "";
      this.sNameLast = "";
      this.sGhostFirst = "";
      this.sGhostLast = "";

      if (this.bPerso) {
        this.sNameFirst = this.user.firstName;
        this.sNameLast = this.user.lastName;
        this.sGhostFirst = this.user.firstGhost;
        this.sGhostLast = this.user.lastGhost;
        this.sNameFull = this.getFullName();
      }
    },
    aprUpdate() {
      if (this.bPerso) {
        this.user.fullName = this.getFullName();
        this.user.firstName = this.sNameFirst;
        this.user.lastName = this.sNameLast;
        this.user.civility = this.nCiv;
        this.user.newIdnOk = this.bIdn;
      }
      this.user.birthday = this.getDateConcat(false,false,'/');
      this.user.metier = this.sMetier;
      this.user.mobile = this.sMobile;
      this.user.email = this.sEmail;
    },
    aprUpdateOld() {
      var oUser = this.user;
      if (this.bPerso) {
        this.sNameFull = this.getFullName();
        oUser.fullName = this.sNameFull;
        oUser.firstName = this.sNameFirst;
        oUser.lastName = this.sNameLast;
        oUser.civility = this.nCiv;
        oUser.newIdnOk = this.bIdn;
      }
      oUser.birthday = this.getDateConcat(false,false,'/');
      oUser.metier = this.sMetier;
      oUser.mobile = this.sMobile;
      oUser.email = this.sEmail;
      this.$store.commit('setUser', oUser);
    },
  },
  mounted: function() {
    // console.log('mounted:function');
    this.aprInit(); 
  },
  computed: {
    forceUpdate() {
      // console.log('computed:forceUpdate');
      return '';
    },
    forceRefresh() {
      // console.log('computed:forceRefresh');
      // this.aprInit();
      return '';
    },
    constants() {
      return constants
    },
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
    params() {
      return this.$store.state.params
    },  
  },
}
</script>

<style scoped>
::placeholder {
  color: #aaa;
}
.input-group-prepend {
  background-color: #f0f2f4 !important;
}
.radio_input {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Chrome, Safari, Opera */
  transform: scale(1.5);
}
.radio_label {
  margin-left: 10px;
  margin-right: 20px;
  line-height: 12 px;
}
hr.sep {
  color: #fff;
  border-color: #fff;
  margin: 0.5rem 0;
}
/*
.apr_first {
  text-transform: capitalize;
}
.apr_last {
  text-transform: uppercase;
}
*/
.is_req {
  color: red;
  margin: 0;
}
p.is_req {
  margin-top: 0.25rem;
  font-size: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/misc/ModalApr.vue